import React from 'react';
import moment from 'moment';
import DAPDependentes from './Components/DAPDependentes';
import FieldDefault from '../../../../components/PDFPage/Inputs/Default';
import FieldChecks from '../../../../components/PDFPage/Inputs/CheckGroup';
import logoNotredame from '../../../../assets/layout_set_logo.png';
import * as S from './styles';
import { addMaskCpf } from '../../../../utils';
import { formatMoney } from '../../../../utils/formatValues';

function DAP({ form, dependentesList, valores }) {
    const DATE_FORMAT = 'DD/MM/YYYY';
    const FORMAT_API = 'MM/DD/YYYY H:mm:ss';

    const { endereco } = form;

    const extraDependentes = Array.from({ length: 4 - form.dependentes.length }, () => ({}));

    return (
        <>
            <S.Container>
                <S.HeaderDAP>
                    <S.Logo src={logoNotredame} />
                    <S.AlignHeader>
                        <S.LabelDAC>Termo de Opção de Continuidade</S.LabelDAC>
                        <S.TextCustom style={{ padding: '0 0 0 27px' }}>
                            (Conforme Arts. 30 e 31 da Lei 9.656/98 e RN 279)
                        </S.TextCustom>
                    </S.AlignHeader>

                    <S.AlignHeader>
                        <FieldChecks
                            style={{ border: 'none' }}
                            options={[
                                {
                                    label: <S.LabelHeader>DEMITIDO ou EXONERADO</S.LabelHeader>,
                                    checked: form.situation.value === '4',
                                },
                                {
                                    label: <S.LabelHeader>APOSENTADO</S.LabelHeader>,
                                    checked: form.situation.value === '2',
                                },
                            ]}
                        />
                    </S.AlignHeader>
                </S.HeaderDAP>

                <S.TitleBarRac>1- DADOS CADASTRAIS TITULAR</S.TitleBarRac>

                <S.GroupFields>
                    <FieldDefault style={{ width: '185px' }} label="Cód. Empresa atual:" value={form.empresa.codigo} />
                    <FieldDefault
                        style={{ width: '185px' }}
                        label="Matrícula Vigente:"
                        value={form.numMatriculaEmpresa}
                    />

                    <FieldDefault style={{ width: '185px' }} label="Plano Vigente:" value={form.planoSaude.nome} />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '100%' }} label="Nome Completo:" value={form.nomeCompleto} />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault
                        style={{ width: '85px' }}
                        label="Data de Nascimento"
                        value={form.dtNascimento && moment(form.dtNascimento, FORMAT_API).format(DATE_FORMAT)}
                    />
                    <FieldDefault style={{ width: '30px' }} label="Sexo" value={form.sexo} />
                    <FieldDefault style={{ width: '30px' }} label="EC" value="" />
                    <FieldDefault style={{ width: '135px' }} label="CPF (Obrigatório)" value={addMaskCpf(form.cpf)} />
                    <FieldDefault style={{ width: '135px' }} label="PIS/PASEP" value={form.numPis} />
                    <FieldDefault
                        style={{ width: '140px' }}
                        label="Cartão Nacional de Saúde"
                        value={form.numCartaoSus}
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '100%' }} label="Nome Completo da Mãe:" value={form.nomeMae} />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '95px' }} label="CEP" value={endereco?.cep} />
                    <FieldDefault style={{ width: '400px' }} label="Rua/AV." value={endereco?.logradouro} />
                    <FieldDefault style={{ width: '60px' }} label="Nº" value={endereco?.numero} />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '200px' }} label="Bairro" value={endereco?.bairro} />
                    <FieldDefault style={{ width: '200px' }} label="Cidade" value={endereco?.cidade} />
                    <FieldDefault style={{ width: '55px' }} label="UF" value={endereco?.uf} />
                    <FieldDefault
                        style={{ width: '100px' }}
                        label="Nº Telefone Fixo ou Celular"
                        value={`(${form.celular.ddd})${' '} ${form.celular.numero}`}
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault
                        style={{ width: '100%' }}
                        label="Email - meio oficial de recepção de boletos e comunicados (Obrigatório)"
                        value={form.email}
                    />
                </S.GroupFields>

                <S.TitleBarRac>
                    2- DADOS DEPENDENTES (Desde que inscritos na vigência do contrato de trabalho*)
                </S.TitleBarRac>

                {[...dependentesList, ...extraDependentes].map((dependente, index) => (
                    <DAPDependentes formDependente={dependente} index={index} />
                ))}

                <S.TitleBarRac>
                    3- VALOR DA TAXA MENSAL EM R$ (A tabela por faixa etária está disponível no portal da operadora na
                    área restrita do beneficiário )
                </S.TitleBarRac>

                <S.GroupFields>
                    <S.BoxValues style={{ width: '40%' }}>
                        <S.BoxValuesText style={{ justifyContent: 'flex-start', margin: '2px 0 0 10px' }}>
                            Cobrança
                        </S.BoxValuesText>
                        <S.BoxValuesText style={{ justifyContent: 'flex-start', margin: '2px 0 0 10px' }}>
                            ({valores.tipoMensalidade !== 'faixaEtaria' ? 'X' : '  '}) Preço Único - Taxa Média (
                            {valores.tipoMensalidade === 'faixaEtaria' ? 'X' : '  '}) Preço Faixa Etária
                        </S.BoxValuesText>
                    </S.BoxValues>

                    <S.BoxValues style={{ width: '20%' }}>
                        <FieldDefault
                            style={{ width: '100%', height: '100%' }}
                            label="Titular"
                            value={formatMoney(valores.valorMensalTitular)}
                        />
                    </S.BoxValues>

                    <S.BoxValues style={{ width: '20%' }}>
                        <FieldDefault
                            style={{ width: '100%', height: '100%' }}
                            label="Dependente(s)"
                            value={formatMoney(valores.valorMensalidadeDependentes)}
                        />
                    </S.BoxValues>

                    <S.BoxValues style={{ width: '20%' }}>
                        <FieldDefault
                            style={{ width: '100%', height: '100%' }}
                            label="Valor - Primeira Mensalidade"
                            value={formatMoney(valores.valorMensalTitular + valores.valorMensalidadeDependentes)}
                        />
                    </S.BoxValues>
                </S.GroupFields>

                <S.TitleBarRac>4- DADOS SOBRE A CONTRIBUIÇÃO E PERÍDODO DE MANUTENÇÃO NO PLANO DE SAÚDE</S.TitleBarRac>

                <S.GroupFields>
                    <FieldDefault
                        style={{ width: '40%', height: '30px', display: 'flex', alignItems: 'center' }}
                        label="Data de Início da Contribuição"
                        value={form.contributionDate.value && moment(form.contributionDate.value).format(DATE_FORMAT)}
                    />

                    <FieldDefault
                        style={{ width: '40%', height: '30px', display: 'flex', alignItems: 'center' }}
                        label="Data da comunicação do Aviso Prévio ou Aposentadoria"
                    />

                    <S.TitleValidity>
                        <S.BoxValuesText style={{ height: '10px', fontWeight: 'bold' }}>
                            Vigência do Período de Manutenção
                        </S.BoxValuesText>

                        <S.ContainerValidity>
                            <FieldDefault
                                style={{ width: '100%', height: '20px', display: 'flex', alignItems: 'center' }}
                                label="Vigência da Cobertura"
                                value={form.stayCompany && moment(form.stayCompany.value[0]).format(DATE_FORMAT)}
                            />

                            <FieldDefault
                                style={{ width: '100%', height: '20px', display: 'flex', alignItems: 'center' }}
                                label="Término da Cobertura"
                                value={
                                    form.stayCompany?.value[1]
                                        ? moment(form.stayCompany.value[1]).format(DATE_FORMAT)
                                        : 'Vitalício'
                                }
                            />
                        </S.ContainerValidity>
                    </S.TitleValidity>
                </S.GroupFields>

                <S.GroupFields>
                    <S.BoxValues style={{ width: '32%', height: '13px' }}>
                        <S.BoxValuesText>Operadoras</S.BoxValuesText>
                    </S.BoxValues>

                    <FieldDefault
                        style={{ width: '23%', height: '13px', padding: '0 0 0 5px' }}
                        label="Data de Início da Contribuição"
                    />

                    <FieldDefault
                        style={{ width: '25%', height: '13px', padding: '0 0 0 5px' }}
                        label="Data de Término da Contribuição"
                    />

                    <FieldDefault
                        style={{ width: '20%', height: '13px', padding: '0 0 0 30px' }}
                        label="Total de Meses"
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '32%', height: '20px' }} label="Atual" />
                    <FieldDefault style={{ width: '23%', height: '20px' }} label=" " />
                    <FieldDefault style={{ width: '25%', height: '20px' }} label=" " />
                    <FieldDefault
                        style={{
                            width: '20%',
                            height: '20px',
                            paddingLeft: '45px',
                        }}
                        label={
                            form.contributionYears.value
                                ? +form.contributionYears.value * 12 + +form.contributionMonths.value
                                : ''
                        }
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '32%', height: '20px' }} label="Atual(1)" />
                    <FieldDefault style={{ width: '23%', height: '20px' }} label=" " />
                    <FieldDefault style={{ width: '25%', height: '20px' }} label=" " />
                    <FieldDefault style={{ width: '20%', height: '20px' }} label=" " />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '32%', height: '20px' }} label="Atual(2)" />
                    <FieldDefault style={{ width: '23%', height: '20px' }} label=" " />
                    <FieldDefault style={{ width: '25%', height: '20px' }} label=" " />
                    <FieldDefault style={{ width: '20%', height: '20px' }} label=" " />
                </S.GroupFields>

                <S.GroupFields>
                    <S.BoxValuesText style={{ fontWeight: '700', padding: '0 0 0 5px' }}>
                        DADOS REEMBOLSO
                    </S.BoxValuesText>
                </S.GroupFields>

                <S.GroupFields>
                    <S.Text>
                        Autorizo a NotreDame Intermédica a depositar na conta corrente por mim indicada abaixo, os
                        valores de reembolso das despesas cobertas pela operadora, realizadas por mim ou por meu(s)
                        dependente(s), cabendo a mim a responsabilidade de informar a operadora quaisquer alterações que
                        venham a ocorrer na conta indicada, observado o plano contratado.
                    </S.Text>
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '15%', height: '100%' }} label="BANCO(CÓDIGO)" />
                    <FieldDefault style={{ width: '40%', height: '100%' }} label="NOME DO BANCO" />
                    <FieldDefault style={{ width: '15%', height: '100%' }} label="Nº DA AGÊNCIA" />
                    <FieldDefault style={{ width: '15%', height: '100%' }} label="Nº CONTA CORRENTE" />
                    <FieldDefault style={{ width: '15%', height: '100%' }} label="DV" />
                </S.GroupFields>

                <S.TitleBarRac>5- DECLARAÇÃO</S.TitleBarRac>

                <S.GroupFields style={{ flexDirection: 'column' }}>
                    <S.Text>
                        Declaro para os fins do disposto nos artigos 30 e 31 da Lei 9656/98, regulamentados pela RN nº
                        279 e suas atualizações, ter ciência dos direitos e deveres assegurados pela referida Lei e
                        Resoluções e, declaro que OPTEI pela continuidade neste ato a responsabilidade pelo pagamento
                        integral das mensalidades, observadas as informações constantes no verso deste termo.
                    </S.Text>
                    <S.Text>
                        Tem ciência de que o boleto para pagamento, assim como toda a comunicação de aviso de vencimento
                        de boleto, inadimplência, descredenciamento de rede e aviso de cancelamento,{' '}
                        <S.FontBold style={{ letterSpacing: '1px' }}>
                            NÃO SERÃO ENVIADOS ATRAVÉS DOS CORREIOS, E SIM ENVIADOS AO E-MAIL INFORMADO NO ITEM 01 DESTE
                            TERMO DE OPÇÃO DE CONTINUIDADE
                        </S.FontBold>
                        , em até 10 dias antes da data de vencimento.
                    </S.Text>
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '40%', height: '100%' }} label="Local e Data" />
                    <FieldDefault
                        style={{ width: '60%', height: '100%' }}
                        label="Assinatura do titular ou responsável legal em caso de beneficiário menor de idade"
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <S.Text>
                        {`* Entenda-se por "Produtos Notre Dame" os planos de saúde originalmente da Notre Dame Seguradora 
                   S.A (Reg.ANS 006980), incorporada pela Notre Dame Intermédica (Reg.ANS 359017).`}
                    </S.Text>
                </S.GroupFields>
            </S.Container>

            <S.SpacingPage style={{ height: '40px' }} />

            <S.Container>
                <S.HeaderDAP style={{ justifyContent: 'flex-start' }}>
                    <S.Logo src={logoNotredame} />
                    <S.AlignHeader>
                        <S.LabelDAC>Termo de Opção de Continuidade</S.LabelDAC>
                        <S.TextCustom style={{ padding: '0 0 0 27px' }}>
                            (Conforme Arts. 30 e 31 da Lei 9.656/98 e RN 279)
                        </S.TextCustom>
                    </S.AlignHeader>
                </S.HeaderDAP>

                <S.TitleBarRac>6- INFORMAÇÕES GERAIS: OPÇÃO DE CONTINUIDADE NO PLANO DE SAÚDE</S.TitleBarRac>

                <S.GroupFields style={{ flexDirection: 'column' }}>
                    <S.TextInfoGenaral>•6. 1. Prazos de Direito</S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        6. 1. 1. O prazo para a opção de continuidade na condição de beneficiário, pelo titular e seus
                        dependentes inscritos na vigência do contrato de trabalho, é de até de 30 (trinta) dias, após o
                        comunicado da empresa, que deverá ser formalizado no ato da comunicação do aviso prévio, a ser
                        cumprido ou indenizado, ou da comunicação da aposentadoria.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        6. 1. 2. Demitidos ou exonerados sem justa causa. O período de manutenção será igual a 1/3 (um
                        terço) do tempo durante o qual contribuiu para o pagamento da contraprestação pecuniária do
                        plano privado de assistência à saúde, sendo-lhe garantido um período mínimo de 06 (seis) meses
                        e, no máximo, um período de 24 (vinte e quatro) meses.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral> 6. 1. 3. Aposentados: </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        - Com menos de 10 (dez) anos de contribuição: o direito de permanência no plano será
                        proporcional ao tempo de contribuição, à razão de I (um) ano para cada ano de contribuição. -
                        Com 10 (dez) anos de contribuição: o direito de permanência no plano será garantido por prazo
                        indeterminado, observadas as condições previstas no item 6.5 abaixo.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>• 6.2. Da Vigência do Período de Manutenção: </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        A vigência do período de manutenção será contada a partir da efetivação do cadastro.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>• 6.3. Da Mensalidade: </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        6.3.1 O beneficiário assumirá o pagamento integral do plano de assistência à saúde que
                        corresponde ao valor pago pelo empregador somado a contribuição paga pelo empregado (titular e
                        dependentes), podendo ser cobrado por preço único (taxa média) ou por faixa etária, observada a
                        informação do Item 3 deste Termo que reflete as condições contratuais pactuadas.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        6.3.2. As mensalidades deverão ser pagas até a data de vencimento, por meio de boleto enviado ao
                        endereço eletrônico declarado neste termo.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        6.3.3. O 1º boleto será encaminhado após a realização do cadastro, prorrogado para 10 dias, o
                        que não significa alteração da data de vencimento dos boletos subsequentes. O vencimento da 2ª
                        mensalidade ocorrerá após 30 dias da data de vigência do contrato.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        6.3.4. As mensalidades serão reajustadas na mesma periodicidade e percentuais aplicados a
                        Empresa Contratante.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>•6.4. Da Carteira de Identificação:</S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        A nova carteira de identificação com o período de manutenção da condição de beneficiário será
                        enviada ao endereço informado. A utilização do Plano de Saúde também poderá ser realizada com a
                        apresentação da Carteirinha Virtual, disponível através do NotreDame APP ou no portal de
                        serviços www.gndi.com.br.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        •6.5 Da Perda do Direito dos Beneficiários titulares e seus dependentes aos direitos dos artigos
                        30 e 3 1 da Lei 9656/98:
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        6.5.1. A perda do direito a manutenção da condição de beneficiário, se dará nas seguintes
                        hipóteses:
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        a) pelo término dos prazos estabelecidos na Lei e reproduzidos no item 6.1 deste Termo;
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        b) quando o beneficiário titular for admitido em novo emprego;
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        c) na falta do pagamento da mensalidade do plano em prazo superior a 30 (trinta) dias de seu
                        vencimento;
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        d) por fraude praticada pelo Beneficiário Titular ou dependentes ou devido a inobservância das
                        obrigações estabelecidas na lei ou no Contrato firmado entre Contratante e a Intermédica;ou
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        e) quando do cancelamento do contrato firmado entre a Intermédica e a Contratante.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        •6.6. As disposições deste Termo são informações gerais ao ex-empregado, sendo preservados todos
                        os direitos e
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        deveres assegurados pela Lei 9656/98 e sua regulamentação, de forma que qualquer alteração nas
                        condições contratuais vigentes com a Contratante ou na legislação vigente, serão aplicadas no
                        que couber a este Termo, mesmo que retroativamente, se assim a lei dispuser.
                    </S.TextInfoGenaral>
                    <S.TextInfoGenaral>•6.7. Da documentação obrigatória </S.TextInfoGenaral>
                    <S.TextInfoGenaral>
                        Na opção pela manutenção da condição de beneficiário deverá ser apresentada a documentação
                        informada no comunicado para Opção de Continuidade, apresentado pela empresa contratante.
                    </S.TextInfoGenaral>
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '40%', height: '100%' }} label="Local e Data" />
                    <FieldDefault
                        style={{ width: '60%', height: '100%' }}
                        label="Assinatura do titular ou responsável legal em caso de beneficiário menor de idade"
                    />
                </S.GroupFields>
            </S.Container>

            <S.SpacingPage style={{ height: '40px' }} />

            <S.Container>
                <S.TextInfoGenaral>Nome da Empresa: {form.empresa && form.empresa.nome}</S.TextInfoGenaral>

                <S.FontBold
                    style={{
                        letterSpacing: '1px',
                        fontSize: '8px',
                        padding: '10px 20px',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    COMUNICADO PARA OPÇÃO PELA CONTINUIDADE ARTs. 30 e 31 DA LEI PLANOS DE SAÚDE - LEI NO 9656/98
                </S.FontBold>

                <S.TextInfoGenaral>
                    É garantido aos ex-empregados, demitidos ou exonerados sem justa causa ou aposentados que
                    contribuíram mensalmente para o pagamento da contraprestação pecuniária do plano privado de
                    assistência médica em decorrência de vínculo empregatício, o direito de manterem a condição de
                    beneficiários deste plano, nas mesmas condições de cobertura de que gozavam quando da vigência do
                    vínculo de emprego, desde que assumam o pagamento integral da respectiva contraprestação
                    pecuniária.(valor pago pelo empregador + contribuição paga pelo empregado: titular e dependente (s),
                    podendo ser cobrado por preço único (taxa média) ou por faixa etária).
                </S.TextInfoGenaral>

                <S.TextInfoGenaral> Não são consideradas contribuições:</S.TextInfoGenaral>
                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    a) valores pagos pelo Titular relacionados à contribuição de dependentes e / ou agregados;
                </S.TextInfoGenaral>
                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    b) valores pagos pelo Titular correspondentes à coparticipação;
                </S.TextInfoGenaral>
                <S.TextInfoGenaral>
                    Tal benefício é extensivo aos dependentes inscritos quando da vigência do contrato de trabalho,
                    sendo certo que serão excluídos do plano ao término dos prazos estabelecidos em lei para manutenção
                    do benefício ou na hipótese de perderem a condição de dependência prevista no contrato. O direito de
                    opção pela manutenção ou não no plano privado de assistência médico deverá ser manifestado em até
                    30(trinta) dias, contados da comunicação do Aviso Prévio ou da comunicação da Aposentadoria, por
                    meio do Termo de Opção de Continuidade.
                </S.TextInfoGenaral>
                <S.TextInfoGenaral>
                    Tendo lido, o <S.TextBold>COMUNICADO PARA OPÇÃO</S.TextBold> sobre os direitos dos Arts. 30 e 31 da
                    Lei no 9.656/98 - Lei de Planos de Saúde, declaro:
                </S.TextInfoGenaral>
                <S.TextInfoGenaral>
                    <S.TextBold>(  ) Opção pela não</S.TextBold> continuidade da condição de beneficiário no Plano de
                    Assistência à Saúde;
                </S.TextInfoGenaral>
                <S.TextInfoGenaral>
                    <S.TextBold>(  ) Opção pela continuidade</S.TextBold> da condição de beneficiário no Plano de
                    Assistência à Saúde.
                </S.TextInfoGenaral>

                <S.TextInfoGenaral>
                    <S.TextBold>
                        Caso a opção seja pela continuidade, deverá ser encaminhado a documentação abaixo:
                    </S.TextBold>
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    - Cópia deste documento assinado pelo Beneficiário Titular e pelo Responsável Contratante;
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    - Cópia do último holerite ou documentos emitidos pela empresa que demonstrem os descontos
                    referentes à contribuição ao Plano de assistência à saúde;
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    - Comprovante de residência em nome do titular;{' '}
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    - Cópias do RG / CPF ou CNH do titular e dependente(s) quando maiores de 18 anos;
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    - Cartão SUS (Sistema Unico de Saúde) do titular e dependente(s);
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    - Cópia do Termo de Rescisão do Contrato de Trabalho;{' '}
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    - No caso de Aposentado: apresentar além dos documentos citados acima, cópia da Carta de Concessão
                    da Aposentadoria do INSS.
                </S.TextInfoGenaral>

                <S.TextInfoGenaral>
                    <S.TextBold>
                        O boleto para pagamento será encaminhado ao beneficiário Titular, após a efetivação de cadastro.
                    </S.TextBold>
                </S.TextInfoGenaral>

                <S.TextInfoGenaral>
                    <S.TextBold>
                        Informações Referente ao Desligamento do Funcionário (PREENCHIMENTO EXCLUSIVO PELA EMPRESA
                        CONTRATANTE):
                    </S.TextBold>
                </S.TextInfoGenaral>

                <S.TextInfoGenaral>
                    Nome do Funcionário
                    ______________________________________________________________________CPF_________________________
                </S.TextInfoGenaral>

                <S.TextInfoGenaral>1 - O Beneficiário foi excluído por:</S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    (  ) demissão ou exoneração sem justa causa (  ) aposentadoria (  ) demissão após aposentado
                </S.TextInfoGenaral>

                <S.TextInfoGenaral>
                    2- O beneficiário demitido ou exonerado sem justa causa é um Beneficiário aposentado que continuava
                    trabalhando na Contratante?
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>(  ) Sim (  ) Não</S.TextInfoGenaral>

                <S.TextInfoGenaral>
                    3- O Beneficiário contribuía para o pagamento do plano privado de assistência à saúde?
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>(  ) Sim (  ) Não</S.TextInfoGenaral>

                <S.TextInfoGenaral>
                    4- Por quanto tempo o Beneficiário contribuiu para o pagamento do plano privado de assistência à
                    Saúde?
                </S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>
                    __________ Anos, __________ Meses
                </S.TextInfoGenaral>

                <S.TextInfoGenaral>5- O ex-empregado optou pela sua manutenção como Beneficiário?</S.TextInfoGenaral>

                <S.TextInfoGenaral style={{ padding: '0px 20px 0px 20px' }}>(  ) Sim (  ) Não</S.TextInfoGenaral>

                <S.TextInfoGenaral>
                    <S.TextBold>Data e Local,__________________________________</S.TextBold>
                </S.TextInfoGenaral>
            </S.Container>
        </>
    );
}

export default DAP;
